<template>
  <DefaultLayout />
  <InitializationWizard />
</template>

<script setup lang="ts">
import { DefaultLayout } from '@fondationcss/ui';
import InitializationWizard from '@/components/initialization-wizard.vue';
</script>
